import {Text,Input,Button, Heading} from "@chakra-ui/react";
import React, { useState } from 'react';
import Cards from "react-credit-cards";

  import 'react-credit-cards/es/styles-compiled.css'
import { useNavigate, useSearchParams } from "react-router-dom";
  
const PaymentsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const amount = searchParams.get('amount');
  const [number, SetNumber] = useState("");
  const [name, SetName] = useState("");
  const [date, SetDate] = useState("");
  const [cvc, SetCvc] = useState("");
  const [focus, SetFocus] = useState("");
  const handlePay = ()=>{
    if(number.length<16){
        alert('card number should be 16 digits ')
    }
    else if(name.includes('1')||name.includes('2')||name.includes('3')||name.includes('4')||name.includes('5')||name.includes('6')||name.includes('7')||name.includes('8')||name.includes('9')||name.includes('0')){
        alert('no name have numbers in it. please write correct name.')
    }
    else if(cvc.length>3){
        if(cvc.length===4){
            if(number[0]!==3 &&(number[1]!==7||number[1]!==4)){
                alert("cvv length 4 is aplicable only in american express cards.")
            }else{
                alert('payment done.')
            }
        }else{
            alert("cvv length should be 3.")
        }
    }else{
        alert('payment done.');
        navigate('/users');
    }
    
  }
  return (
    <div>
        <Heading>Payment</Heading>
        <Text> pay {amount}</Text>
        <br/>
        <div>
        <Cards
          number={number}
          name={name}
          expiry={date}
          cvc={cvc}
          focused={focus}
        />
      </div>

      <br />
      <form>
        <div className="row">
          <div className="col-sm-11">
            <label htmlFor="name">Card Number</label><br/>
            <Input
              type="text"
              className="form-control"
              value={number}
              name="number"
              width={'40%'}
              onChange={(e) => {
                    SetNumber(e.target.value);
                
              }}
              onFocus={(e) => SetFocus(e.target.name)}
            ></Input>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-11">
            <label htmlFor="name">Card Name</label><br/>
            <Input
              type="text"
              className="form-control"
              value={name}
              name="name"
              width={'40%'}
              onChange={(e) => {
                SetName(e.target.value);
              }}
              onFocus={(e) => SetFocus(e.target.name)}
            ></Input>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <label htmlFor="name">Expiration Date</label><br/>
            <Input
              type="text"
              name="expiry"
              className="form-control"
              value={date}
              width={'40%'}
              onChange={(e) => {
                SetDate(e.target.value);
              }}
              onFocus={(e) => SetFocus(e.target.name)}
            ></Input>
          </div>
          <div className="col-sm-5">
            <label htmlFor="name">CVV</label><br/>
            <Input
              type="tel"
              name="cvc"
              className="card"
              value={cvc}
              width={'40%'}
              onChange={(e) => {
                SetCvc(e.target.value);
              }}
              onFocus={(e) => SetFocus(e.target.name)}
            ></Input>
          </div>
        </div>
        <Button onClick={handlePay}>Pay</Button>
      </form>
        
    </div>
  )
}

export default PaymentsPage